const makeCategoriesMap = (categories) =>
  categories.reduce((map, category) => {
    map[category.id] = category;
    return map;
  }, {});

export default makeCategoriesMap;
